import { Box, PDF_FONT_SIZE } from '@/components';
import type { CSSProperties, FC } from 'react';

type Props = {
  text: string;
  href: string;
  textStyle?: CSSProperties;
  textWrapperStyle?: CSSProperties;
  width?: string | number;
  align?: 'left' | 'center' | 'right';
  paddingHorizontal?: 'small' | 'medium';
};

const paddingHorizontalMap = {
  small: 1,
  medium: 2,
};

export const LinkCell: FC<Props> = ({
  text,
  href,
  textStyle,
  textWrapperStyle,
  width,
  align,
  paddingHorizontal,
}) => {
  return (
    // NOTE: height: 100%を付けると印刷時にページ全体に引き伸ばされるので注意
    <Box
      display="flex"
      width={width}
      alignItems="center"
      padding={`4px ${paddingHorizontalMap[paddingHorizontal ?? 'medium']}px`}
      {...textWrapperStyle}
    >
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        style={{ textDecoration: 'underline', color: 'black' }}
      >
        <p
          style={{
            margin: 0,
            lineHeight: 1.25,
            fontSize: PDF_FONT_SIZE.MD,
            wordBreak: 'break-all',
            overflowWrap: 'anywhere',
            whiteSpace: 'pre-wrap',
            textAlign: align ?? 'left',
            fontFamily: 'Noto Sans JP',
            ...textStyle,
          }}
        >
          {text}
        </p>
      </a>
    </Box>
  );
};
